import { render } from "./SnsLogin.vue?vue&type=template&id=2e25b0bd"
import script from "./SnsLogin.vue?vue&type=script&lang=js"
export * from "./SnsLogin.vue?vue&type=script&lang=js"

import "./SnsLogin.vue?vue&type=style&index=0&id=2e25b0bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__